"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadModule = void 0;
var discoveryServiceUtils_1 = require("./utils/discoveryServiceUtils");
function loadModule(fullModuleName, files) {
    if (files === void 0) { files = []; }
    return __awaiter(this, void 0, void 0, function () {
        var moduleInfo;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!window.dynamicModules) {
                        window.dynamicModules = [];
                    }
                    if (!fullModuleName) {
                        throw new Error('Param `fullModuleName` is required for `loadModule` function, e.g. `await loadModule("ui-kit:latest")`');
                    }
                    moduleInfo = getModuleInfo(fullModuleName);
                    return [4 /*yield*/, loadFilesIfNeeded(moduleInfo, { files: files })];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, getModuleInstance(moduleInfo.name)];
                case 2: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
exports.loadModule = loadModule;
function getModuleInstance(moduleName) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, waitFor(function () { return window[moduleName]; }, 30)];
                case 1:
                    _a.sent();
                    return [2 /*return*/, window[moduleName].default];
            }
        });
    });
}
function loadFilesIfNeeded(moduleInfo, config) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var _i, _b, file;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!(typeof moduleInfo.isFilesLoaded === 'undefined')) return [3 /*break*/, 7];
                    moduleInfo.isFilesLoaded = false;
                    if (!!((_a = config === null || config === void 0 ? void 0 : config.files) === null || _a === void 0 ? void 0 : _a.length)) return [3 /*break*/, 2];
                    return [4 /*yield*/, getModuleConfig(moduleInfo.fullName)];
                case 1:
                    config = _c.sent();
                    _c.label = 2;
                case 2:
                    _i = 0, _b = config.files;
                    _c.label = 3;
                case 3:
                    if (!(_i < _b.length)) return [3 /*break*/, 6];
                    file = _b[_i];
                    return [4 /*yield*/, loadFile(file)];
                case 4:
                    _c.sent();
                    _c.label = 5;
                case 5:
                    _i++;
                    return [3 /*break*/, 3];
                case 6:
                    moduleInfo.isFilesLoaded = true;
                    _c.label = 7;
                case 7: return [2 /*return*/, waitFor(function () { return moduleInfo.isFilesLoaded; }, 60)];
            }
        });
    });
}
function getModuleInfo(fullModuleName) {
    var moduleName = fullModuleName.split(':')[0];
    var index = window.dynamicModules.findIndex(function (module) { return module.name === moduleName; });
    if (index !== -1) {
        return window.dynamicModules[index];
    }
    var newModuleInfo = { name: moduleName, fullName: fullModuleName };
    window.dynamicModules.push(newModuleInfo);
    return newModuleInfo;
}
function getModuleConfig(moduleName) {
    return __awaiter(this, void 0, void 0, function () {
        var response, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fetch("".concat((0, discoveryServiceUtils_1.getDiscoveryServiceUrl)(), "/modules/").concat(moduleName, "?v=").concat(+new Date()))];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.json()];
                case 2:
                    e_1 = _a.sent();
                    console.error(e_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function loadFile(src) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!/.js/i.test(src)) return [3 /*break*/, 2];
                    return [4 /*yield*/, loadScript(src)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    if (!/.css/i.test(src)) return [3 /*break*/, 4];
                    return [4 /*yield*/, loadStyles(src)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    });
}
function loadStyles(src) {
    if (document.querySelector("[src=\"".concat(src, "\"]"))) {
        return null;
    }
    var entry = document.createElement('link');
    entry.setAttribute('href', src);
    entry.setAttribute('rel', 'stylesheet');
    entry.setAttribute('type', 'text/css');
    return appendDynamicFile(entry);
}
function loadScript(src) {
    if (document.querySelector("[src=\"".concat(src, "\"]"))) {
        return null;
    }
    var entry = document.createElement('script');
    entry.setAttribute('src', src);
    entry.setAttribute('type', 'text/javascript');
    return appendDynamicFile(entry);
}
function appendDynamicFile(entry) {
    var promise = new Promise(function (resolve, reject) {
        entry.addEventListener('load', resolve);
        entry.addEventListener('error', reject);
    });
    document.head.appendChild(entry);
    return promise;
}
function waitFor(resolver, waitingMaxTimeSeconds) {
    var waitingTime = 0;
    return new Promise(function (resolve, reject) {
        (function run() {
            if (resolver()) {
                resolve(undefined);
            }
            else if (waitingTime >= waitingMaxTimeSeconds * 1000) {
                reject();
            }
            else {
                waitingTime += 100;
                setTimeout(run, 100);
            }
        })();
    });
}
